import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sa-bonus-event-summary',
  templateUrl: './bonus-event-summary.component.html',
  styleUrls: ['./bonus-event-summary.component.scss'],
})
export class BonusEventSummaryComponent implements OnInit {
  @Input() selectedBonusEvent: any;

  constructor() {}

  ngOnInit(): void {}
}
